import React, { useEffect, useState } from "react";
import LinearGoldText from "./linear-gold-text.tsx";
import "./game-payout-rate.css";

export default function GamePayoutItem({ item, isMobile }) {
  const [rate, setRate] = useState("99.99");

  useEffect(() => {}, []);

  useEffect(() => {
    generateRandomRate();

    const intervalId = setInterval(() => {
      generateRandomRate();
    }, 60000);
    return () => clearInterval(intervalId);
  }, []);

  const generateRandomRate = () => {
    const randomNum = (Math.random() * 20 + 80).toFixed(2); // `.toFixed(2)` ensures 2 decimal places
    setRate(() => randomNum);
  };

  return (
    <div
      style={{ flexDirection: "column", display: "flex" }}
      key={item}
      className="container"
    >
      <img
        className="logo"
        src={require(`../images/rate-payout-logo/rate-payout-logo-${item}.png`)}
        width="100px"
        height="100px"
        alt="RateLogo"
        style={{ objectFit: "contain" }}
      />
      <div style={{ marginTop: "15px" }} />
      <div className="rate-container label">
        <LinearGoldText
          isMobile={isMobile}
          style={{
            fontSize: "14px",
            lineHeight: "16px",
            textAlign: "center",
          }}
        >
          {rate}%
        </LinearGoldText>
      </div>
    </div>
  );
}
